import { render, staticRenderFns } from "./editFeaturedSponsorEdition.vue?vue&type=template&id=56005253"
import script from "./editFeaturedSponsorEdition.vue?vue&type=script&lang=js"
export * from "./editFeaturedSponsorEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports